var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flat"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 53.5,
    fill: "#fccd1d",
    rx: 29,
    ry: 7.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 53.5,
    fill: "#f9a215",
    rx: 20,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,25A22,22,0,1,0,22.86,45l7.82,7.84a2,2,0,0,0,2.64,0L41.14,45A22,22,0,0,0,54,25Z",
    fill: "#dd051d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 25,
    fill: "#fff",
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,34h4a0,0,0,0,1,0,0v1.27A1.73,1.73,0,0,1,27.27,37h-.54A1.73,1.73,0,0,1,25,35.27V34A0,0,0,0,1,25,34Z",
    fill: "#111315"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,34h4a0,0,0,0,1,0,0v1.27A1.73,1.73,0,0,1,37.27,37h-.54A1.73,1.73,0,0,1,35,35.27V34A0,0,0,0,1,35,34Z",
    fill: "#111315"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#212529",
    height: 21,
    rx: 2.05,
    width: 18,
    x: 23,
    y: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,19h2a1,1,0,0,1,1,1v3a1,1,0,0,1-1,1H41a0,0,0,0,1,0,0V19A0,0,0,0,1,41,19Z",
    fill: "#fccd1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,19h2a0,0,0,0,1,0,0v5a0,0,0,0,1,0,0H21a1,1,0,0,1-1-1V20A1,1,0,0,1,21,19Z",
    fill: "#fccd1d"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e6e7e8",
    height: 7,
    width: 18,
    x: 23,
    y: 18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 30,
    fill: "#e6e7e8",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 30,
    fill: "#e6e7e8",
    r: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransit);
export default __webpack_public_path__ + "static/media/transit.355dfc056a5bf3e9dfec03611a1a07b6.svg";
export { ForwardRef as ReactComponent };